import isQA from './isQA';
// @ts-expect-error legacy-hubspot-bender-context is a virtual, undeclared module
import { bender } from 'legacy-hubspot-bender-context';
import loadStyles from './loadStyles';
import { getPortalId } from './getPortalId';
export function loadIframe(iframeSrc, attributes = {}) {
  if (attributes.height === null) {
    delete attributes.height;
  } else {
    attributes.height = attributes.height || '0';
  }
  if (attributes.width === null) {
    delete attributes.width;
  } else {
    attributes.width = attributes.width || '0';
  }
  attributes.style = attributes.style || 'display: none';
  const iframe = document.createElement('iframe');
  iframe.setAttribute('src', iframeSrc);
  if (attributes.onload) {
    iframe.onload = attributes.onload;
    delete attributes.onload;
  }
  if (attributes.onerror) {
    iframe.onerror = attributes.onerror;
    delete attributes.onerror;
  }
  Object.keys(attributes).forEach(key => {
    iframe.setAttribute(key, attributes[key]);
  });
  document.body.appendChild(iframe);
}
function loadWootric() {
  if (!window.hubspot || !window.hubspot.wootricDisabled) {
    loadStyles(`//static.hsappstatic.net/wootric-nps/ex/theme${isQA() ? '-qa' : ''}.css`);
  }
}
function loadDeferredNavSetup() {
  loadStyles(`${bender.staticDomainPrefix}${bender.depPathPrefixes[bender.project]}/bundles/project.css`);
}
let loadDependentsInterval = null;
let tries = 0;
const loadDependents = ({
  startTime
}) => {
  const MIN_PARENT_ASSET_LOADING_THRESHOLD = 3000;
  if (document.readyState === 'complete' && Date.now() - startTime > MIN_PARENT_ASSET_LOADING_THRESHOLD && tries < 1) {
    tries++;
    if (loadDependentsInterval) {
      clearInterval(loadDependentsInterval);
    }
    loadWootric();
  }
};
export default function loadDependentScripts(scopes, gates) {
  loadDeferredNavSetup();
  if (!scopes && !getPortalId()) {
    return;
  }
  const startTime = Date.now();
  loadDependentsInterval = setInterval(loadDependents, 250, {
    startTime,
    gates
  });
}